import { render, staticRenderFns } from "./xxxq.vue?vue&type=template&id=1e63f251&scoped=true"
import script from "./xxxq.vue?vue&type=script&lang=js"
export * from "./xxxq.vue?vue&type=script&lang=js"
import style0 from "./xxxq.vue?vue&type=style&index=0&id=1e63f251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e63f251",
  null
  
)

export default component.exports